/**
 * 页面 SEO metaInfo 构建器
 * @param {Object} vm         Vue 组件实例 (this)
 * @param {string} title      页面标题后缀，如 '首页' | '关于我们'
 * @param {Object} opts       可选覆盖项
 * @param {string} opts.keywords    页面级关键词，覆盖全局
 * @param {string} opts.description 页面级描述，覆盖全局
 * @param {string} opts.imgUrl      页面特色图片 URL
 */
const PAGE_SEO_MAP = {
  'Index': {
    keywords: '佰信纸业,热敏纸,不干胶标签纸,电脑打印纸,收银纸,条码纸,办公用纸,印刷纸张,纸张批发,厂家直销',
    description: '广州佰信纸业有限公司专注于高品质热敏纸、条码不干胶标签、电脑打印纸等办公印刷纸张的研发与生产。提供厂家直销批发，支持规格定制，全国发货。',
  },
  'AboutUs': {
    keywords: '佰信纸业公司简介,造纸企业,纸品生产厂家,广州纸业公司',
    description: '广州佰信纸业有限公司是国内居于前列的大型综合性印刷造纸企业，拥有20多年行业经验，专业生产定制批发收银纸、不干胶纸、电脑打印纸、复印纸等纸制品。',
  },
  'ProductCenter': {
    keywords: '热敏纸,不干胶标签纸,电脑打印纸,收银纸,条码纸,复印纸,印刷纸张,纸品批发',
    description: '佰信纸业产品中心，提供热敏纸、条码不干胶标签、电脑打印纸、收银纸、复印纸等全系列办公印刷纸张，支持规格定制与全国批发。',
  },
  'FactoryDisplay': {
    keywords: '佰信纸业工厂,造纸厂,印刷厂,纸品生产车间,广州工厂',
    description: '佰信纸业工厂展示，拥有先进造纸生产线和印刷设备，现代化生产车间，严格品控体系，确保每一批纸张品质稳定。',
  },
  'SalesNetwork': {
    keywords: '佰信纸业销售网络,纸张销售渠道,纸品经销商,全国发货',
    description: '佰信纸业销售网络覆盖全国，提供厂家直销、批发代理等多种合作模式，高效物流配送，服务全国客户。',
  },
  'ServiceSupport': {
    keywords: '佰信纸业服务支持,纸张定制,规格定制,售后服务,技术支持',
    description: '佰信纸业提供全方位的服务支持，包括纸张规格定制、技术支持、售后保障，为您提供一站式纸品采购解决方案。',
  },
  'NewsTrends': {
    keywords: '佰信纸业新闻,行业动态,纸品资讯,造纸行业新闻',
    description: '佰信纸业新闻动态，发布集团要闻、业务动态及行业资讯，了解佰信纸业最新发展和造纸行业前沿信息。',
  },
  'ContactUs': {
    keywords: '联系佰信纸业,纸品厂家联系方式,广州造纸厂电话,纸张采购咨询',
    description: '联系广州佰信纸业有限公司，提供纸张采购咨询、规格定制、合作洽谈等服务。地址：广东省广州市南国工业区6栋。',
  },
  'Mall': {
    keywords: '佰信纸业商城,纸张在线采购,热敏纸购买,打印纸批发,收银纸零售',
    description: '佰信纸业官方商城，在线选购热敏纸、不干胶标签纸、电脑打印纸、收银纸等办公纸张，厂家直供，品质保证。',
  },
  'Shop': {
    keywords: '纸张在线购买,办公用纸商城,印刷纸张采购,纸品电商',
    description: '佰信纸业商城，在线选购各类办公印刷纸张，厂家直销，正品保障，支持多种支付方式，全国发货。',
  },
  'Cart': {
    description: '佰信纸业购物车，查看已选商品，确认订单信息。',
  },
  'Mine': {
    description: '佰信纸业个人中心，管理您的订单、地址、收藏和优惠券。',
  },
};

export function pageMetaInfo(vm, title = '', opts = {}) {
  const siteName = '广州佰信纸业有限公司';
  const pageTitle = title ? `${title} - ${siteName}` : vm.PageTitle || siteName;
  const imgUrl = opts.imgUrl || vm.$getAssetUrl('/favicon.ico');

  // 页面级专属 SEO：优先用传入的 opts，其次用页面映射，最后用全局 API 数据
  const pageKey = opts.pageKey || vm.$options.name || '';
  const pageSeo = PAGE_SEO_MAP[pageKey] || {};
  const keywords = opts.keywords || pageSeo.keywords || vm.PagekeyWords;
  const description = opts.description || pageSeo.description || vm.PageDescription;

  return {
    title: pageTitle,
    meta: [
      { name: 'keywords', content: keywords },
      { name: 'description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: pageTitle },
      { property: 'og:description', content: description },
      { property: 'og:site_name', content: siteName },
      { property: 'og:url', content: window.location.href },
      { property: 'og:image', content: imgUrl },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: pageTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: imgUrl },
    ]
  };
}
